// Get API key from localStorage or Redux state
const getApiKey = () => {
  return localStorage.getItem('valhalla_api_key') || null
}

// Create headers with API key if available
export const createHeaders = (
  additionalHeaders = {},
  apiKeyOverride = null
) => {
  const apiKey = apiKeyOverride || getApiKey()
  const headers = {
    'Content-Type': 'application/json',
    ...additionalHeaders,
  }

  if (apiKey) {
    headers.apikey = apiKey
  }

  return headers
}

// Axios request wrapper for Valhalla API
export const valhallaRequest = (method, endpoint, data = null, config = {}) => {
  const headers = createHeaders(config.headers)

  const requestConfig = {
    ...config,
    headers,
  }

  if (method.toLowerCase() === 'get') {
    return requestConfig
  }

  return {
    ...requestConfig,
    data,
  }
}

// Helper function to check if API key is available
export const hasApiKey = () => {
  return !!getApiKey()
}
